<section class="aca-mig__card">
  <div class="aca-mig__empty" *ngIf="!loading && !jobs().length">
    <mat-icon>cloud_sync</mat-icon>
    <div class="aca-mig__emptytitle">{{ 'DMS.MIGRATION.EMPTY_JOBS_TITLE' | translate }}</div>
    <div>{{ 'DMS.MIGRATION.EMPTY_JOBS_DESC' | translate }}</div>
  </div>

  <div class="aca-mig__tablewrap" *ngIf="jobs().length">
    <table class="aca-mig__table">
      <thead>
        <tr>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_JOB' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_NAME' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_SOURCE' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_PROGRESS' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_DOCS' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_STATUS' | translate }}</th>
          <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_STARTED' | translate }}</th>
          <th class="aca-mig__th" style="text-align: right">{{ 'DMS.MIGRATION.COL_ACTIONS' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let job of jobs(); trackBy: trackById">
          <td class="aca-mig__td aca-mig__mono">{{ job.id?.slice(0, 8) || '—' }}</td>
          <td class="aca-mig__td">
            {{ job.name }}
            <mat-icon
              *ngIf="job.schedule?.enabled"
              style="font-size: 15px; vertical-align: -3px; color: var(--theme-accent-color)"
              [matTooltip]="('DMS.MIGRATION.SCHED_TOOLTIP' | translate) + ': ' + job.schedule.cron"
            >
              schedule
            </mat-icon>
          </td>
          <td class="aca-mig__td">{{ connectorName(job.sourceConnector) }}</td>
          <td class="aca-mig__td" style="min-width: 140px">
            <mat-progress-bar class="aca-mig__progress" mode="determinate" [value]="percent(job)" />
          </td>
          <td class="aca-mig__td">{{ docsOf(job) }}</td>
          <td class="aca-mig__td">
            <span class="aca-mig__chip" [ngClass]="statusClass(job.status)">{{ statusKey(job.status) | translate }}</span>
          </td>
          <td class="aca-mig__td">{{ dateLabel(job.startedAt || job.createdAt) }}</td>
          <td class="aca-mig__td" style="text-align: right; white-space: nowrap">
            <button
              type="button"
              class="aca-mig__iconbtn"
              *ngIf="job.status === 'draft'"
              [matTooltip]="'DMS.MIGRATION.EDIT' | translate"
              [attr.aria-label]="'DMS.MIGRATION.EDIT' | translate"
              (click)="edit(job)"
            >
              <mat-icon>edit</mat-icon>
            </button>
            <button
              type="button"
              class="aca-mig__iconbtn"
              *ngIf="canRun(job) === 'start'"
              [disabled]="busyId() === job.id || api.available() !== true"
              [matTooltip]="api.available() === true ? ('DMS.MIGRATION.START' | translate) : ('DMS.MIGRATION.NEEDS_BACKEND' | translate)"
              [attr.aria-label]="api.available() === true ? ('DMS.MIGRATION.START' | translate) : ('DMS.MIGRATION.NEEDS_BACKEND' | translate)"
              (click)="control(job, 'start')"
            >
              <mat-icon>play_arrow</mat-icon>
            </button>
            <button
              type="button"
              class="aca-mig__iconbtn"
              *ngIf="job.status === 'running'"
              [disabled]="busyId() === job.id || api.available() !== true"
              [matTooltip]="api.available() === true ? ('DMS.MIGRATION.PAUSE' | translate) : ('DMS.MIGRATION.NEEDS_BACKEND' | translate)"
              [attr.aria-label]="api.available() === true ? ('DMS.MIGRATION.PAUSE' | translate) : ('DMS.MIGRATION.NEEDS_BACKEND' | translate)"
              (click)="control(job, 'pause')"
            >
              <mat-icon>pause</mat-icon>
            </button>
            <button
              type="button"
              class="aca-mig__iconbtn"
              *ngIf="job.status === 'paused'"
              [disabled]="busyId() === job.id || api.available() !== true"
              [matTooltip]="api.available() === true ? ('DMS.MIGRATION.RESUME' | translate) : ('DMS.MIGRATION.NEEDS_BACKEND' | translate)"
              [attr.aria-label]="api.available() === true ? ('DMS.MIGRATION.RESUME' | translate) : ('DMS.MIGRATION.NEEDS_BACKEND' | translate)"
              (click)="control(job, 'resume')"
            >
              <mat-icon>play_arrow</mat-icon>
            </button>
            <button
              type="button"
              class="aca-mig__iconbtn"
              *ngIf="job.status === 'running' || job.status === 'paused'"
              [disabled]="busyId() === job.id || api.available() !== true"
              [matTooltip]="api.available() === true ? ('DMS.MIGRATION.CANCEL_JOB' | translate) : ('DMS.MIGRATION.NEEDS_BACKEND' | translate)"
              [attr.aria-label]="api.available() === true ? ('DMS.MIGRATION.CANCEL_JOB' | translate) : ('DMS.MIGRATION.NEEDS_BACKEND' | translate)"
              (click)="control(job, 'cancel')"
            >
              <mat-icon>stop</mat-icon>
            </button>
            <button
              type="button"
              class="aca-mig__iconbtn"
              [disabled]="busyId() === job.id"
              [matTooltip]="'DMS.MIGRATION.DELETE' | translate"
              [attr.aria-label]="'DMS.MIGRATION.DELETE' | translate"
              (click)="remove(job)"
            >
              <mat-icon>delete_outline</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</section>
